import React, { useEffect, useState } from 'react';
import './relics-stats.css';
import Tippy from '@tippyjs/react';
// import 'tippy.js/animations/shift-away.css';
// import 'tippy.js/animations/scale.css';

// import relics from './data/relics.json';

// const orderedRelics = Object
//     .values(relics)
//     .sort((r1, r2) => r1.name.localeCompare(r2.name));

function abilityValueToString(values) {
    if (Array.isArray(values)) {
        return values.join(' / ');
    } else {
        return values.toString();
    }
}

function camelCaseToSeparated(input) {
    return input
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between lowercase and uppercase
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') // Handle cases like "HTMLParser"
        .toLowerCase(); // Optionally, convert to lowercase
}

const abilityMappings = {
    "AbilityActionDefinitionNoTarget": "No Target",
    "AbilityActionDefinitionUnitTarget": "Unit Target",
    "AbilityActionDefinitionPointTarget": "Point Target",
    "manaCost": "Mana Cost",
    "maxHealthCost": "Max Health Cost",
    "cooldown": "Cooldown",
    "castRange": "Cast Range",
    "castPoint": "Cast Point",
    "primaryRadius": "Primary Radius",
};

const iconMappings = {
    "manaCost": "mana-cost.png",
    "maxHealthPctCost": "hp-cost.png",
    "cooldown": "cooldown.png",
    "castRange": "cast-range.png",
    "castPoint": "cast-point.png",
};

const tierMappings = {
    0: 'Standard',
    1: 'Ultimate',
};

let relics = [];

let relicsById = {}
let leadersById = {};

let stats = undefined;
let relicStats = undefined;

function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
    useEffect(() => {
        const mq = window.matchMedia(query);
        const handler = e => setMatches(e.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [query]);
    return matches;
};

const RelicsStats = () => {
    const [message, setMessage] = useState('Loading relics...');
    const [relicList, setRelicList] = useState(relics);

    const isMobile = useMediaQuery('(max-width: 600px)');

    useEffect(() => {
        if (relics.length > 0) {
            setMessage(null);
            setRelicList(relics);
            return;
        }

        const relicsUrl = `${process.env.REACT_APP_ASSETS_URL}/assets/relics.json`;
        const leadersUrl = `${process.env.REACT_APP_ASSETS_URL}/assets/leaders.json`;
        const statsUrl = `${process.env.REACT_APP_ASSETS_URL}/assets/stats.json`;

        Promise.all([
            fetch(relicsUrl).then(res => {
                if (!res.ok) throw new Error('Fetch relics failed');
                return res.json();
            }),
            // fetch(leadersUrl).then(res => {
            //     if (!res.ok) throw new Error('Fetch leaders failed');
            //     return res.json();
            // }),
            // fetch(statsUrl).then(res => {
            //     const json = (res.headers.get('content-type') ?? '').includes('application/json');
            //     if (!res.ok || !json) return {};
            //     return res.json();
            // })
        ])
        .then(results => {
            // [relicsById, leadersById, stats] = results;
            [relicsById] = results

            // relicStats = stats.relicStats != undefined ? stats.relicStats.reduce((acc, relic) => {
            //     acc[relic.relicId] = relic.relicLeaderStats;
            //     return acc
            // }, {}) : undefined;

            relics = Object
                .values(relicsById)
                .filter(relic => relic.enabled == undefined || relic.enabled == true)
                .sort((r1, r2) => r1.name.localeCompare(r2.name));
            setMessage(null);
            setRelicList(relics);
        })
        .catch(err => {
            console.dir(err);
            setMessage('Failed to load relics');
            console.error("Error fetching or processing JSON:", err.message);
        });
    }, []);

    const [tierFilters, setTierFilters] = useState([
        { name: 'Show All', type: null, selected: true },
        { name: 'Standard', tier: 0, selected: false },
        { name: 'Ultimate', tier: 1, selected: false },
    ]);
    
    const [targetFilters, setTargetFilters] = useState([
        { name: 'Show All', type: null, selected: true },
        { name: 'Passive', type: 'passive', selected: false },
        { name: 'Active', type: 'active', selected: false },
    ]);

    const [tooltipFilters, setTooltipFilters] = useState([
        { name: 'Simple', type: 'simple', selected: true },
        { name: 'Advanced', type: 'advanced', selected: false },
    ]);

    const getSelectedFilters = (filters) => {
        return filters.find(filter => filter.selected);
    };

    const filterRelics = (tierFilter, targetFilter) => {
        return relics
            .filter((relic) => {
                const tierResult = 
                    (tierFilter.tier == null) ||
                    (tierFilter.tier == relic.tier);

                const targetResult =
                    (targetFilter.type == null) ||
                    (targetFilter.type == 'passive' && relic.action == null) ||
                    (targetFilter.type == 'active' && relic.action != null);

                return tierResult && targetResult;
            })
    };

    const handleTierFilterClick = (index) => {
        const newFilters = tierFilters.map((filter, i) => ({
            ...filter,
            selected: i === index,
        }));
        setTierFilters(newFilters);
        const selectedTierFilters = getSelectedFilters(newFilters);
        const selectedTargetFilters = getSelectedFilters(targetFilters);
        setRelicList(filterRelics(selectedTierFilters, selectedTargetFilters));
    };

    const handleTargetFilterClick = (index) => {
        const newFilters = targetFilters.map((filter, i) => ({
            ...filter,
            selected: i === index,
        }));
        setTargetFilters(newFilters);
        const selectedTierFilters = getSelectedFilters(tierFilters);
        const selectedTargetFilters = getSelectedFilters(newFilters);
        setRelicList(filterRelics(selectedTierFilters, selectedTargetFilters));
    };

    const handleTooltipFilterClick = (index) => {
        const newFilters = tooltipFilters.map((filter, i) => ({
            ...filter,
            selected: i === index,
        }));
        setTooltipFilters(newFilters);
        const filter = newFilters.find(filter => filter.selected);
        const relicList = document.querySelector('.relic-list');
        if (filter.type == 'simple') {
            relicList.classList.remove('advanced-tooltips');
        }
        if (filter.type == 'advanced') {
            relicList.classList.add('advanced-tooltips');
        }
    };

    return (
        <article className="App-page relics-page">
            <h1>Relics</h1>

            <section className="relics-filter">
                <div className="relics-filter-group">
                    <span className="relics-filter-group-title">Tier:</span>
                    <ul>
                        {tierFilters.map((filter, index) => (
                            <li key={ `tier-${index}` } onClick={() => handleTierFilterClick(index)} className={filter.selected ? 'selected' : ''}>{filter.name}</li>
                        ))}
                    </ul>
                </div>
                <div className="relics-filter-group">
                    <span className="relics-filter-group-title">Type:</span>
                    <ul>
                        {targetFilters.map((filter, index) => (
                            <li key={ `type-${index}` } onClick={() => handleTargetFilterClick(index)} className={filter.selected ? 'selected' : ''}>{filter.name}</li>
                        ))}
                    </ul>
                </div>
                <div className="relics-filter-group">
                    <span className="relics-filter-group-title">Tooltips:</span>
                    <ul>
                        {tooltipFilters.map((filter, index) => (
                            <li key={ `tooltips-${index}` } onClick={() => handleTooltipFilterClick(index)} className={filter.selected ? 'selected' : ''}>{filter.name}</li>
                        ))}
                    </ul>
                </div>
            </section>

            {message ? (
                <p>{message}</p>
            ) : (
                <div>
                    <ul className="relic-list">
                        { relicList.map((relic, i) => {
                            var values = { };
                            if (relic.action && relic.action.val) {
                                values = relic.action.val;
                            }

                            return (
                                <li key={ relic.id }>
                                <figure className="relic-thumbnail">
                                <Tippy
                                    placement={isMobile ? 'bottom' : 'auto'}
                                    // animation="scale"
                                    duration="0"
                                    popperOptions={isMobile ? {
                                        modifiers: [{ name: 'flip', enabled: false }]
                                    } : undefined}
                                    content={(
                                        <article className="relic">
                                            <div className="relic-content">
                                                <header className="relic-header">
                                                    <img className="relic-icon" src={ `${process.env.REACT_APP_ASSETS_URL}/${relic.icon}` } alt={ relic.name } />
                                                    <h3 className="relic-title">{ relic.name }</h3>
                                                </header>
                                                <main className="relic-main">
                                                    <section className="relic-ability">
                                                        <ul>
                                                            <li key={ `${relic.id}-tier` }>
                                                                <div className="key">Tier</div>
                                                                <div className="value">{ tierMappings[relic.tier] ?? '?' }</div>
                                                            </li>
                                                            <li key={ `${relic.id}-type` }>
                                                                <div className="key">Type</div>
                                                                <div className="value">{ relic.action ? (abilityMappings[relic.action.tag] ?? '') : 'Passive' }</div>
                                                            </li>
                                                        </ul>
                                                    </section>
                                                    <section className="relic-description">
                                                        <p dangerouslySetInnerHTML={{ __html: relic.description?.replace(/\r?\n/g, '<br>') }}/>
                                                    </section>
                                                    <section className="relic-simpleDescription">
                                                        <p dangerouslySetInnerHTML={{ __html: relic.simpleDescription?.replace(/\r?\n/g, '<br>') }}/>
                                                    </section>
                                                    <section className="relic-values">
                                                        <ul>
                                                            {relic.values.map(value => (
                                                                <li key={ `${relic.id}-${value.title}` }>
                                                                    <div className="key">{value.title}</div>
                                                                    <div className="value" dangerouslySetInnerHTML={{ __html: value.description }}></div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </section>
                                                    <section className="relic-upgrades">
                                                        {Object.values(relic.upgrades).map((upgrade) => {
                                                            return (
                                                                <div key={ upgrade.name } className="relic-upgrade">
                                                                    <div className="relic-upgrade-type">{ upgrade.type?.toUpperCase() }: { upgrade.title }</div>
                                                                    <div className="relic-upgrade-description" dangerouslySetInnerHTML={{ __html: upgrade.description?.replace(/\r?\n/g, '<br>') }}/>
                                                                </div>
                                                            )
                                                        })}
                                                    </section>
                                                    <section className="relic-stats">
                                                        {Object.entries(values).map(([key, value]) => (
                                                            <div key={ `value-${key}` } className="relic-stats-value" title={abilityMappings[key]}>
                                                                <img src={iconMappings[key]} alt={abilityMappings[key]}/>
                                                                <span dangerouslySetInnerHTML={{ __html: value.description }}></span>
                                                            </div>
                                                        ))}
                                                    </section>
                                                </main>
                                            </div>
                                            {relicStats != null ? (
                                                <aside className="relic-aside">
                                                    <div className="relic-aside-title">Popular Leaders (patch: { stats.patch })</div>
                                                    <ul className="relic-aside-leaders">
                                                        {Object.entries(relicStats[relic.id] ?? {}).slice(0, 5).map(([relicId, leaderStat]) => {
                                                            const leader = leadersById[leaderStat.leaderId];
                                                            return (
                                                                <li key={ `leader-${leaderStat.leaderId}` }>
                                                                    <figure className="relic-aside-leader-image">
                                                                        <img src={ `${process.env.REACT_APP_ASSETS_URL}/${leader?.icon}` } alt=""/>
                                                                    </figure>
                                                                    <div className="relic-aside-values">
                                                                        <div>
                                                                            <span className="key">Picks: </span>
                                                                            <span className="value">{ leaderStat.picks ?? '0' }</span>
                                                                        </div>
                                                                        <div>
                                                                            <span className="key">Win Rate: </span>
                                                                            <span className="value">{ leaderStat.winRate != undefined ? (leaderStat.winRate * 100).toFixed(2) + '%' : '-' }</span>
                                                                        </div>
                                                                        <div>
                                                                            <span className="key">Top 4 Rate: </span>
                                                                            <span className="value">{ leaderStat.top4Rate != undefined ? (leaderStat.top4Rate * 100).toFixed(2) + '%' : '-' }</span>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            )
                                                        })}
                                                    </ul>
                                                </aside>
                                            ) : "" }
                                        </article>
                                    )}>
                                    <button>
                                        <img className="relic-icon" src={ `${process.env.REACT_APP_ASSETS_URL}/${relic.icon}` } alt={ relic.name } />
                                    </button>
                                </Tippy>
                                </figure>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            )}
        </article>
    );
};

export default RelicsStats;
